import { set, toggle } from "@/utils/vuex";

export default {
  setDrawer: set("drawer"),
  toggleDrawer: toggle("drawer"),
  showLoadingDialog(state, payload) {
    state.loading = payload;
  },
  showErrorDialog(state, payload) {
    state.showErrorDialog = payload;
  },
  showErrorMessage(state, payload) {
    state.errorMessage = payload;
  },
  showErrorCode(state, payload) {
    state.errorCode = payload;
  },
  reload(state, payload) {
    state.reload = payload;
  },
  showBulkRefundDialog(state, payload) {
    state.showBulkRefundDialog = payload;
  },
  showBroadcastDialog(state, payload) {
    state.showBroadcastDialog = payload;
  },
  showMapDialog(state, payload) {
    state.showMapDialog = payload;
  },
  showQRDialog(state, payload) {
    state.showQRDialog = payload;
  },
  QRDialogMessage(state, payload) {
    state.QRDialogMessage = payload;
  },
  QRDialogName(state, payload) {
    state.QRDialogName = payload;
  },
  QRDialogDownloadFileName(state, payload) {
    state.QRDialogDownloadFileName = payload;
  },
};
